module.exports = __webpack_public_path__ + "static/media/grs-logo.683619b2.png";